import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  lang: 'ja',
  // cityVal: '東京',
  JHSS: {},
  JHSS_customer_param: {},
  JHSS_addressee_param: {},
  JHSS_orderManage_param: {},
  JHSS_xiaobaolist_param: {},
  JHSS_orderCheck_param: {},
  JHSS_signManage_param: {},
  JHSS_deliveryManage_param: {},
  JHSS_deliveryDetail_param: {},
  JHSS_tempeoraryManage_param: {},
  JHSS_containerInfo_param: {},
  JHSS_diaoduInfo_param: {},
  JHSS_containerQuery_param: {},
  JHSS_orderHistory_param: {},
  JHSS_formalManage_param: {},
  JHSS_reservedCargoManage_param: {}
}


export default new Vuex.Store({
  state,
  mutations
})
